import React, { useState } from 'react';

export function FaxImagePreview({ groupId, imageId, alt }) {
  const [open, setOpen] = useState(false);
  if (!groupId || !imageId) {
    return <div className="fax-thumb fax-thumb-empty" aria-label="no image" />;
  }
  const src = `/api/fax-inbox/image/${groupId}/${imageId}`;
  return (
    <>
      <button
        className="fax-thumb"
        type="button"
        onClick={() => setOpen(true)}
        aria-label={`Open preview for ${alt || 'fax'}`}
      >
        <img src={src} alt={alt || 'fax page 1'} loading="lazy" />
      </button>
      {open && (
        <div className="fax-preview-backdrop" onClick={() => setOpen(false)} role="dialog" aria-modal="true">
          <div className="fax-preview-frame" onClick={e => e.stopPropagation()}>
            <button className="fax-preview-close" type="button" onClick={() => setOpen(false)} aria-label="Close preview">×</button>
            <img src={src} alt={alt || 'fax full size'} />
          </div>
        </div>
      )}
    </>
  );
}

// Editable page preview: renders ONE page image at a usable size inside a
// position:relative wrapper and renders `children` (absolutely-positioned
// overlay boxes) on top of it. Used by the signature-placement editor so the
// boxes can be dragged/resized over the rendered page. `wrapperRef` is
// forwarded to the relative container so the caller can read its
// getBoundingClientRect() while dragging (pixel→normalized conversion).
//
// Unlike the thumbnail above, this is NOT a button (the boxes capture pointer
// events) — it just shows the page. It renders nothing when there's no image.
export function FaxEditablePagePreview({ groupId, imageId, alt, wrapperRef, children }) {
  if (!groupId || !imageId) {
    return <div className="fax-page-edit fax-thumb-empty" aria-label="no image" />;
  }
  const src = `/api/fax-inbox/image/${groupId}/${imageId}`;
  return (
    <div className="fax-page-edit" ref={wrapperRef}>
      <img className="fax-page-edit-img" src={src} alt={alt || 'fax page'} draggable={false} />
      {children}
    </div>
  );
}
